import React from 'react'
import styled from 'styled-components'

import { Translate } from '@hozana/intl/Translate'
import { IMAGE_SIZES } from '@hozana/styling/image'
import { EVENT_ORIGIN, TRACKING_SOURCE } from '@hozana/tracking/constants'

import { Button } from 'elements/button/Button'
import { Cell } from 'elements/layout/Cell'
import { Row } from 'elements/layout/Row'
import { Shadow } from 'elements/layout/Shadow'
import { VariableHeightImage } from 'elements/media/VariableHeightImage'
import { Link } from 'elements/text/Link'
import { P } from 'elements/text/P'
import { Text } from 'elements/text/Text'

import { PAGE } from 'routes/constants'

import { getCommunityMembersText } from 'modules/community/functions'
import type { TCommunity } from 'modules/community/types'

import { GUIDE_CARD, GUIDE_CARD_BUTTON, GUIDE_CARD_LINK } from '../constants'

export type TGuideCommunityCardProps = {
  community: TCommunity
  variant?: string
}

const StyledImage = styled(VariableHeightImage)`
  && {
    // Needed to overwrite ExternalContent style. TODO: Remove ExternalContent style
    margin: 0 auto 10px;
  }
`

export const GuideCommunityCard: TFC<TGuideCommunityCardProps> = ({ community, variant }) => {
  const to = {
    pathname: PAGE.COMMUNITY_VIEW_LANDING,
    query: {
      communityId: community.id,
      communitySlug: community.slug,
      course: 'direct',
      origin: EVENT_ORIGIN.GUIDE_CARD,
      source: TRACKING_SOURCE.GUIDE_CARD,
    },
  }

  return (
    <Shadow
      as="aside"
      depth="8px"
      radius="medium"
      m="1em auto 1em"
      p="0 0 5px 0"
      bg="white"
      maxW="400px"
      noOverflow
      className={variant ? `${GUIDE_CARD}-${variant}` : GUIDE_CARD}
      display={variant && variant !== 'A' ? 'none' : undefined}
    >
      <StyledImage src={community.picture} size={IMAGE_SIZES.community.medium} alt={community.name} />
      <Link
        to={to}
        asButton={!community.isSeoIndexed}
        color="darkBlue"
        hoverColor="blue"
        target="_blank"
        noReferrer
        className={GUIDE_CARD_LINK}
      >
        <P bold fontSize="1.5em" p="16px">
          {community.name}
        </P>
      </Link>
      <Row p="16px" align="middleBetween" nowrap maxW="100%">
        <Cell>
          <Text color="yellow" fontSize="19px">
            <Translate values={{ count: community.nbMembers }}>{getCommunityMembersText(community)}</Translate>
          </Text>
        </Cell>
        <Cell>
          <Button
            colors="darkBlue"
            color="white" /** force the color to be white, to avoid replacing it with the default color of the links which is blue */
            valueLink={{ to, asButton: !community.isSeoIndexed, target: '_blank', noReferrer: true }}
            size="bigger"
            className={GUIDE_CARD_BUTTON}
          >
            trans:guide:words.i-subscribe
          </Button>
        </Cell>
      </Row>
    </Shadow>
  )
}
